class TeamsSelect extends HTMLSelectElement {
  static get observedAttributes() { return ['no_change_option']; }

  attributeChangedCallback(name, ov, val) {
    switch (name) {
      case 'no_change_option':
        this.no_change_option = (val === 'true');
    }
  }

  constructor() {
    super();
    this.no_change_option = false;
    this.template = document.createElement('template');
  }

  async connectedCallback() {

    let object_id = document.querySelector("#object_id").value


    let for_groups = this.getAttribute("for_groups")=="true";
    if(for_groups) {
      this.data_binder = new DataBinder("/admin/groups/"+object_id+"/teams", true);
    } else {
      this.data_binder = new DataBinder("/admin/domains/"+object_id+"/teams", true);
    }

    this.data_binder.register(this);
    if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
  }

  requestUpdate(data){
    if(this.getAttribute("for_groups")=="true") {
      this.data = data.data;
    } else {
      this.data = data;
    }

    let options = this.data.map(team => `<option value="${team.team_id}">${team.name}</option>`).join("");

    let no_change_option = this.no_change_option ? "<option value='no_change'>No Change</option>" : ""

    this.template.innerHTML =`
    ${no_change_option}
    <option value="">Select</option>
    ${options}
    `

    let value = this.value;
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));
    
    this.value = (value || this.getAttribute("data-selected"));
    if(this.selectedOptions.length == 0) {
      this.value = this.getAttribute("no_change_option") == "true" ? "no_change" : ""
    }
  }
}

customElements.define('teams-select', TeamsSelect, {extends: 'select'});
